import {
  Activity,
  Upload,
  Settings,
  LogOut,
  ChartCandlestick,
  PackageOpen,
  Store,
  CalendarRange,
} from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";
import { TenoreT } from "../features/TenoreT";
import { Button } from "../features/ui/button";
import { useAuth } from '../features/auth/hooks/useAuth';
const mobileNav = [
  { to: "/overview", icon: Activity },
  { to: "/ecommerce", icon: ChartCandlestick },
  { to: "/wholesale", icon: PackageOpen },
  { to: "/retail", icon: Store },
  { to: "/key-events", icon: CalendarRange },
  { to: "/upload", icon: Upload },
  { to: "/settings", icon: Settings },
];

export default function MobileSidebar() {
  const location = useLocation();
  const { logout } = useAuth();
  const handleLogout = () => {
    logout();
  };
  
  

  return (
    <aside className="relative z-40 w-16 bg-black flex flex-col items-center py-4 gap-6 border-r border-white/10 flex-shrink-0">
      {/* Added flex-shrink-0 to prevent shrinking */}
      <div className="flex justify-center items-center border-b-2 w-full">
                    <TenoreT className="text-black dark:text-white mb-4" />
                  </div>
      <div className="flex-1 flex flex-col items-center gap-4 overflow-y-auto scroll-smooth mt-4">
        {mobileNav.map(({ to, icon: Icon }) => {
          const isActive = location.pathname.startsWith(to);
          return (
            <Link
              key={to}
              to={to}
              className={clsx(
                "p-2 rounded-md transition-colors duration-150", // Added transition
                isActive
                  ? "bg-white text-black"
                  : "text-white/70 hover:text-white"
              )}
            >
              <Icon className="h-5 w-5" />
            </Link>
          );
        })}
      </div>

      <div className="mt-auto">
        <Button
                onClick={handleLogout}
                variant="ghost"
                size="icon"
                className="text-black dark:text-white flex-shrink-0"
              >
          <LogOut className="h-5 w-5" />
        </Button>
      </div>
    </aside>
  );
}
